import { render, staticRenderFns } from "./NutritionEditor.vue?vue&type=template&id=5f7c9972&scoped=true"
import script from "./NutritionEditor.vue?vue&type=script&lang=js"
export * from "./NutritionEditor.vue?vue&type=script&lang=js"
import style0 from "./NutritionEditor.vue?vue&type=style&index=0&id=5f7c9972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c9972",
  null
  
)

export default component.exports